/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiKey } from './ApiKey';
import {
    ApiKeyFromJSON,
    ApiKeyFromJSONTyped,
    ApiKeyToJSON,
    ApiKeyToJSONTyped,
} from './ApiKey';

/**
 * 
 * @export
 * @interface ListApiKeys200Response
 */
export interface ListApiKeys200Response {
    /**
     * 
     * @type {Array<ApiKey>}
     * @memberof ListApiKeys200Response
     */
    apiKeys: Array<ApiKey>;
    /**
     * Total number of active keys across all pages
     * @type {number}
     * @memberof ListApiKeys200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ListApiKeys200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ListApiKeys200Response
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof ListApiKeys200Response
     */
    hasMore: boolean;
}

/**
 * Check if a given object implements the ListApiKeys200Response interface.
 */
export function instanceOfListApiKeys200Response(value: object): value is ListApiKeys200Response {
    if (!('apiKeys' in value) || value['apiKeys'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('hasMore' in value) || value['hasMore'] === undefined) return false;
    return true;
}

export function ListApiKeys200ResponseFromJSON(json: any): ListApiKeys200Response {
    return ListApiKeys200ResponseFromJSONTyped(json, false);
}

export function ListApiKeys200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListApiKeys200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'apiKeys': ((json['apiKeys'] as Array<any>).map(ApiKeyFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'hasMore': json['hasMore'],
    };
}

export function ListApiKeys200ResponseToJSON(json: any): ListApiKeys200Response {
    return ListApiKeys200ResponseToJSONTyped(json, false);
}

export function ListApiKeys200ResponseToJSONTyped(value?: ListApiKeys200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'apiKeys': ((value['apiKeys'] as Array<any>).map(ApiKeyToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'hasMore': value['hasMore'],
    };
}

